import React from "react";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import Approuter from "./routes/router";
import BodyBackgroundSync from "./components/BodyBackgroundSync";

function App() {
  return (
    <BrowserRouter>
      <BodyBackgroundSync />
      <Approuter />
    </BrowserRouter>
  );
}

export default App;
